module.exports = __webpack_public_path__ + "img/free-icon-fire-extinguisher-5524203.f5384f27.png";